const ufeApi = require('services/api/ufeApi');
const { userXTimestampHeader } = require('utils/Headers');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Create+BI+Account+API

function createBiAccount(input) {
    const url = '/api/bi/account';

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: userXTimestampHeader(),
            body: JSON.stringify(input)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = createBiAccount;
